<template>
  <CCol class="text-white body d-flex justify-content-start">
    <!--<div>
      <h3 class=" my-5" v-html="$t('auth.login.text.collaboration-cloud')"></h3>
      <CButton class="btn-primary font-weight-bold px-4 py-3 font-xl">
        {{ $t('auth.login.text.request-demo') }}
      </CButton>
    </div>-->
  </CCol>
</template>

<script>
export default {
  name: 'RequestDemo',
}
</script>

<style lang="scss" scoped>
.body {
  margin-top: 30%;
}
p {
  line-height: 1.2rem;
}
</style>
